/**
 * The detail pages' title and byline below md, where the title is not a hero
 * but the first line under the picture: the product's own setting, shared so
 * the project's opens on the same word in the same place and the same type.
 * Colour stays with each page, which knows its ground.
 */
export const MOBILE_DETAIL_TITLE =
    'm-0 font-sans text-[1.625rem] leading-[1.15] font-medium tracking-[-0.025em]';

/** The line under it — the supplier or the practice — a step down. */
export const MOBILE_DETAIL_BYLINE =
    'm-0 mt-1.5 font-sans text-[0.9375rem] leading-[1.22] font-medium tracking-[-0.01em]';
